module.exports = __webpack_public_path__ + "static/b2b_bottom-bdfdb22b31c012009125e9791f42e49c.png";